
import {
  GETSHEDULEMEETING,
  CREATESHEDULEMEETING,
 
} from "../actions/type";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup partyTypeList Cases
    case   GETSHEDULEMEETING:
      return {
        ...state,
        shedulemeeting: action.payload.data,
      };
    case CREATESHEDULEMEETING:
      return {
        ...state,
        createshedulemeeting: action.payload.success,
      };
  

    default:
      return state;
  }
}
